export default __webpack_public_path__ + "static/char-s-42-ko-b03c5b3c2509960855c9fea3b34f4fc6.webp";